<template>
  <div>
    <TheHeader
      with-menu
      class="md:mb-8"
    />
    <ColLayout
      v-if="completeUser"
      :subtitle="$t('My profile')"
      :title="user.name"
      class="hidden md:block md:min-h-75"
    >
      <ProfileInvestmentEntities />
      <template slot="right">
        <div class="mb-2 font-roman text-xl">{{ user.name }}</div>
        <ProfileSummary :attributes="completeUser.attributes" />
      </template>
    </ColLayout>
    <BaseSection
      v-if="completeUser"
      class="md:hidden mb-15"
    >
      <BaseTitleGroup
        :subtitle="$t('My profile')"
        :title="user.name"
        class="mb-2"
      />
      <ProfileSummary :attributes="completeUser.attributes" />
      <ProfileInvestmentEntities />
    </BaseSection>
    <TheFooter />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import TheHeader from '../components/TheHeader.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseSection from '../components/BaseSection.vue';
import ColLayout from './partials/ColLayout.vue';
import ProfileSummary from './partials/ProfileSummary.vue';
import ProfileInvestmentEntities from './partials/ProfileInvestmentEntities.vue';
import TheFooter from '../components/TheFooter.vue';

export default {
  name: 'Profile',
  metaInfo: {
    title: 'Mon profil',
  },
  components: {
    TheHeader,
    BaseTitleGroup,
    BaseSection,
    ProfileSummary,
    ColLayout,
    ProfileInvestmentEntities,
    TheFooter,
  },
  computed: {
    ...mapState('auth', ['user', 'completeUser']),
  },
  methods: {
    ...mapActions('auth', ['fetchCompleteUser']),
  },
};
</script>

<style lang="css" scoped>
</style>
